import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.444 2h11.112A4.444 4.444 0 0 1 22 6.444v11.112A4.444 4.444 0 0 1 17.556 22H6.444A4.444 4.444 0 0 1 2 17.556V6.444A4.444 4.444 0 0 1 6.444 2zm11.723 11.445h-2.27l-2.598-4.5a2.564 2.564 0 0 0-.292 3.048l3.248 5.627a.889.889 0 1 0 1.54-.889l-.871-1.508h1.243a.89.89 0 1 0 0-1.778zM7.39 15.556c-.198 0-.395.042-.576.122l-.608 1.053a.889.889 0 1 0 1.54.889l.829-1.436a1.43 1.43 0 0 0-1.185-.628zm5.294-2.111h-2.528l3.756-6.506a.889.889 0 0 0-1.54-.89L12 6.696l-.373-.645a.889.889 0 1 0-1.54.889l.887 1.534-2.871 4.972h-2.27a.889.889 0 1 0 0 1.778h8.039a1.286 1.286 0 0 0-1.188-1.778z"
});

var SvgAppStore = function SvgAppStore(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgAppStore;